
import axios from '../api/axios';

export const fetchArticleCommandes = async () => {
  const response = await axios.get('/article-commandes');
  return response.data;
};
